export const HDR_MAP_LOADER = {
  rgb: "rgb",
  pmremGenerator: "pmremGenerator",
  pmremGeneratorEXR: "pmremGeneratorEXR"
}

export function loadHDRMap(scene, renderer, hdrLoader = HDR_MAP_LOADER.pmremGeneratorEXR, shouldContinue = () => true) {
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/comfy_cafe_1k.hdr';
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/gray complex.exr';
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/gray copy high contrast lighter.exr';
  //const hdrUrl = 'https://qc-cdn.s3.amazonaws.com/hdr/gray%20copy%20high%20contrast%20lighter.exr';
  //const hdrUrl = '/hdr/pine_attic_4k.hdr';
  //const hdrUrl = '/3d/hdr/BackLight_4K_29.hdr';
  //const hdrUrl = 'https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/hdr/BackLight_4K_29.hdr';
  const hdrUrl = 'https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/hdr/Enfironment%20fil%20light.exr';

  if (hdrLoader === HDR_MAP_LOADER.rgb) {
    const rgbeLoader = new window.RGBELoader();
    rgbeLoader.load(hdrUrl, (hdrEquirect) => {
      const pmrem = new window.THREE.PMREMGenerator(renderer);
      pmrem.compileEquirectangularShader();
      const envMap = pmrem.fromEquirectangular(hdrEquirect).texture;
      envMap.mapping = window.THREE.EquirectangularReflectionMapping;
      scene.environment = envMap;
      scene.environmentIntensity = 4;
      scene.environment.needsUpdate = true;
      //scene.background = envMap;

      hdrEquirect.dispose();
      pmrem.dispose();
    });
  } else if (hdrLoader === HDR_MAP_LOADER.pmremGenerator) {
    const pmremGenerator = new window.THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    const rgbeLoader = new window.RGBELoader();
    rgbeLoader.load(hdrUrl, (hdrTexture) => {
        const envMap = pmremGenerator.fromEquirectangular(hdrTexture).texture;
        scene.environment = envMap;
        //scene.background = envMap;
        scene.environmentIntensity = 1;
        scene.environment.needsUpdate = true;

        // Optional: Clean up resources
        hdrTexture.dispose();
        pmremGenerator.dispose();
      },
      undefined, // onProgress
      (error) => {
        console.error('An error occurred loading the HDR texture:', error);
      });
  } else if (hdrLoader === HDR_MAP_LOADER.pmremGeneratorEXR) {
    const pmremGenerator = new window.THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    return new Promise(resolve => {
      const finishWithError = error => {
        pmremGenerator.dispose();
        console.error('An error occurred loading the HDR texture:', error);
        resolve(null);
      };

      new window.EXRLoader().load(hdrUrl, texture => {
        if (!shouldContinue()) {
          texture.dispose();
          pmremGenerator.dispose();
          resolve(null);
          return;
        }

        try {
          const exrCubeRenderTarget = pmremGenerator.fromEquirectangular(texture);
          const newEnvMap = exrCubeRenderTarget ? exrCubeRenderTarget.texture : null;
          scene.environment = newEnvMap;
          scene.environmentIntensity = 1;
          if (newEnvMap) {
            newEnvMap.needsUpdate = true;
          }
          texture.dispose();
          pmremGenerator.dispose();
          resolve(newEnvMap);
        } catch (error) {
          texture.dispose();
          finishWithError(error);
        }
      }, undefined, finishWithError);
    });
  }
}
